// extracted by mini-css-extract-plugin
export default {"mobileRemove":"settingsMobileHeader_mobileRemove__UEwSw","mobileName":"settingsMobileHeader_mobileName__Dy7dU"};